/**
 * konstanty pro cesty Api volani
 */
export default {
    RESTORE_TOKEN: 'Portal/RestoreToken',
    LOGIN: 'Portal/Login',
    LOGOUT: 'Portal/Logout',
    CAPTCHA: 'Captcha',
    REGISTRACE: 'Portal/Registrace',
    RESTORE: 'Portal/Restore',
    LOGIN_CERT: 'Portal/LoginCert',
    OBNOVENI_HESLA_SERV: 'Portal/PasswordRestore',
    OBNOVENI_EMAIL_SERV: 'Portal/ZmenaEmailu/Potvrzeni',
    FILE_UPLOAD: '/Upload',
    FILE_UPLOAD_AMLODKAZ: 'AMLodkaz/Upload',
    PRUVODCE_VH: '/pruvodceVH',
    PRUVODCE_VYPIS: '/pruvodceVYPIS',
    AKCIONAR_SMS: 'Akcionar/Pristup/SMS',
    LOGIN_PXKLIC: 'Portal/ReinitMobil',
    NOVY_UCET: 'Portal/Novyucet',
    ZADOST: '/NZ/zadost',
    ZADOST_DOWNLOAD_PDF: '/NZ/zadost/DownloadPDF',
    LANGUAGE: 'Portal/Language'
};
